import { getTermsValue } from '@/packages/JsonQuery';

import { nonEmptyArrayOr } from '../../../../../utils/nonEmptyArrayOr';
import { type ITagGroupConfig, type TagKeywordsSchema } from '../types';

export const wordsExclude: ITagGroupConfig = {
  get({ jsonQuery }) {
    const value = getTermsValue('description_exclude')(jsonQuery) || [];

    const tagsGroup: TagKeywordsSchema[] = value.map(key => ({
      group: 'wordsExclude',
      text: `Не содержит "${key}"`,
      data: key,
    }));

    return nonEmptyArrayOr(tagsGroup);
  },
  delete({ jsonQuery, onChange }, tag: TagKeywordsSchema) {
    const currentValue = getTermsValue('description_exclude')(jsonQuery) || [];
    const nextValue = nonEmptyArrayOr(currentValue.filter(item => item !== tag.data));

    onChange({
      action: 'setExcludeWords',
      arguments: [nextValue],
    });
  },
};
